import { QueryClient } from '@tanstack/react-query';
import { opoContactQueries, opoQueries } from '@/queries/opo';

export const opoByIdLoader = (queryClient: QueryClient) => (opoId: string) => {
  return queryClient.fetchQuery({
    ...opoQueries.item(opoId),
  });
};

export const opoContactByIdLoader = (queryClient: QueryClient) => (contactId: string) => {
  return queryClient.fetchQuery({
    ...opoContactQueries.item(contactId),
  });
};
